import BackPageHeading from "components/BackPageHeading.component";
import { ReadOnlyWhenRestricted } from "components/capability";
import { useAdminCapabilities } from "hooks/useAdminCapabilities";
import { AdminCapability } from "shared/utils/capabilities";
import DiscountCodesCard from "pages/settings/DiscountCodesCard";
import PATHS from "shared/constants/paths";
import { translate } from "shared/languages";

// Pengaturan -> Promosi & Reward -> Kode Diskon. Thin page chrome only; the
// list and form live in the card, matching LoyaltyProgramPage/ReferralProgramPage.
const DiscountCodesPage = () => {
  const { isRestricted } = useAdminCapabilities();
  const readOnly = isRestricted(AdminCapability.PromoReward);

  return (
    <>
      <BackPageHeading
        title={translate("discountCodes.card_title")}
        backTo={PATHS.SETTINGS}
      />
      <ReadOnlyWhenRestricted capability={AdminCapability.PromoReward}>
        <DiscountCodesCard readOnly={readOnly} />
      </ReadOnlyWhenRestricted>
    </>
  );
};

export default DiscountCodesPage;
